export function selectedClassLocationValue(
  selected: string,
  locations: Array<{ _id: string; name: string }>,
): string {
  if (!selected || selected === 'All') {
    return 'All';
  }

  const match = locations.find(
    (location) => location._id === selected || location.name === selected,
  );
  return match?._id ?? selected;
}
